<template>
  <div>
    <v-icon :color="theVal ? 'green' : 'red'"
      >mdi-{{ theVal ? trueIcon : falseIcon }}</v-icon
    >
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "CheckOrMinus",
  props: {
    val: null,
    trueIcon: { type: String, default: "check" },
    falseIcon: { type: String, default: "minus" },
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {
    theVal: function () {
      let v = this.val;
      if (!v) return false;
      if (typeof v === "string") {
        let lc = v.toLowerCase();
        if (v == "0" || v == "-1" || v == "false") return false;
        if (lc == "no" || lc == "n") return false;
      }
      return true;
    },
  },
};
</script>

<style scoped></style>
